import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useInView } from 'react-intersection-observer';
import FullWidthImage from '../../components/FullWidthImage';
import TextAlignment from '../../components/TextAlignment';
import Video from '../../components/Video';
import Cutouts from '../../components/Cutouts';
import renderContentfulBody from './richTextRenderer/renderContentfulBody';
import getThemeClass from '../../utils/getThemeClass';
import styles from './FullWidthImageSection.module.css';
import CloudinaryMedia from '../../components/CloudinaryMedia';

/**
 * @param {FF.ContentfulFullWidthImageSection} props
 */
export default function FullWidthImageSection({
  backgroundImage,
  backgroundVideo,
  body,
  cloudinaryMedia,
  cutouts,
  textAlignment,
  withScrim,
}) {
  const { ref, inView } = useInView({
    fallbackInView: true,
    triggerOnce: true,
  });

  let wrapperClass = styles.wrapper;
  if (backgroundVideo || cloudinaryMedia?.[0]?.resource_type === 'video') {
    wrapperClass += ` ${styles.withVideo}`;
  }

  let mediaComponent = null;
  if (cloudinaryMedia) {
    mediaComponent = (
      <CloudinaryMedia
        {...cloudinaryMedia[0]}
        autoPlay={inView}
        fullScreenVideo
        lazyload
        breakpoints={[480, 1000, 2400]}
      />
    );
  } else if (backgroundVideo) {
    mediaComponent = (
      <Video
        autoPlay
        fullScreen
        description={backgroundVideo.description}
        url={backgroundVideo.url}
      />
    );
  } else if (backgroundImage) {
    mediaComponent = (
      <GatsbyImage
        alt={backgroundImage?.description}
        image={backgroundImage.gatsbyImageData}
      />
    );
  } else {
    throw new Error('need to provide either image or cloudinaryMedia');
  }

  return (
    <Cutouts cutouts={cutouts}>
      <FullWidthImage
        className={wrapperClass}
        media={mediaComponent}
        ref={ref}
        withScrim={withScrim}
      >
        {body && (
          <TextAlignment
            alignment={textAlignment}
            className={`${styles.bodyWrapper} ${getThemeClass('Dark')}`}
          >
            <div
              className={`${styles.bodyContent} ${
                withScrim ? '' : styles.bodyTextShadow
              }}`}
            >
              {renderContentfulBody(body)}
            </div>
          </TextAlignment>
        )}
      </FullWidthImage>
    </Cutouts>
  );
}
